<template>
  <div class="pageJFT">
    <XR-head titleText="我的JKT" :rightShow="true"></XR-head>    
    <div class="total balance" v-if="!loaded">
      <p class="title">JKT总额</p>
      <p class="money">{{JFTInfo.Coin.toFixed(4)}}</p>
    </div>
    <div class="total account-address" v-if="!loaded">
      <p class="title"></p>
      <p class="address" ref="JFTText">{{UserInfo.Purse}}</p>
      <p class="copybtn" @click="copyText()">复制地址</p>
    </div>

    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <router-link to="/usercenter/JFTRecharge">
          <mu-list-item title="JKT充值">
            <mu-icon slot="left" value=":fa fa-money7"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <!-- <mu-divider shallowInset/>
        <router-link to="/usercenter/JFTWithdraw">
          <mu-list-item title="JFT提现">
            <mu-icon slot="left" value=":fa fa-withdraw"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link> -->
        <mu-divider shallowInset/>
        <router-link to="/usercenter/JFTStream">
          <mu-list-item title="JKT查询">
            <mu-icon slot="left" value=":fa fa-money"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import {ErrorCode} from '../../../../util/errorcode'
export default {
  data() {
    return {
      loaded : true,
      UserInfo:{
        Purse:''
      },
      JFTInfo:{
        Coin:0
      }
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    
    this.getUserInfo()
    this.getJFTInfo()
  },
  methods: {
    getUserInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(res.IsSuccess){        
          ths.UserInfo = res.Data;
        }
      });
    },
    getJFTInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/JftServer/GetJftAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/JFTActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.JFTInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    copyText: function(){
    var oInput = document.createElement('input')
        oInput.value = this.UserInfo.Purse
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        document.body.removeChild(oInput)
        this.$refs.XRtoast.success("复制成功", true)
    }
}
}
</script>
<style>
.pageJFT .total{
  background: white;
  padding: 20px 20px;
}
.pageJFT .total.balance{
  overflow: hidden;
 background: url('/static/us-top-xn.png');
  background-size: 100% 100%;
}
.pageJFT .title{
  line-height: 24px;
  font-size: 14px;
}
.pageJFT .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageJFT .total.balance .title{
  color:white;
}
.pageJFT .total.balance .money{
  color:white;
}


.pageJFT .sub-nav{
  background: white;
  margin-top: 10px;
}

.pageJFT .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 10px 0 20px;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageJFT .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/jft/local/jft.vue